import React from 'react';
import DataDrivenGuidePage from '../../components/guides/DataDrivenGuidePage';

const DtcDecoderGuidePage = () => <DataDrivenGuidePage slug="guide-dtc-decoder" />;

export default DtcDecoderGuidePage;
